import { render, staticRenderFns } from "./commodityInfo.vue?vue&type=template&id=59b91e64&scoped=true&"
import script from "./commodityInfo.vue?vue&type=script&lang=js&"
export * from "./commodityInfo.vue?vue&type=script&lang=js&"
import style0 from "./commodityInfo.vue?vue&type=style&index=0&id=59b91e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b91e64",
  null
  
)

export default component.exports